<template>
  <child-container
      :container-name="containerName"
      :container-title="title"
      overflow-val=""
      overflow-x-val="hidden"
      overflow-y-val="auto"
      ref="container"
      v-on:container-hidden="containerHidden"
      v-on:container-shown="containerShown"
      width="414px"
  >
    <dialogue-creator
        :init-component-id="initComponentId"
        :viewport-i-d="viewportID"
        :client-i-d="clientID"
        ref="dlgCreator"
    ></dialogue-creator>
  </child-container>
</template>

<script setup>
import { reactive, onMounted, watch, ref, nextTick, getCurrentInstance, onBeforeMount } from 'vue';
import ChildContainer from './../ChildContainer/ChildContainer.vue';
import * as oxygenUtil from './../OxygenUtil/oxygenutil.js';
import DialogueCreator from './../DialogueCreator/DialogueCreator.vue';

let props = defineProps({
  title: String,
  viewportID: String,
  clientID: String,
  initComponentId: String
});

let containerName = `container${oxygenUtil.getUUID()}`, container = ref(null), dlgCreator = ref(null);

async function containerShown() {
  console.log('containerShown', 'Comp:', window.devStore.viewPorts.find(e => e.viewportID === props.viewportID).MessageBox);
  dlgCreator.value.textareaProps.messageBoxComponent = dlgCreator.value.inputTextboxProps.messageBoxComponent =
      window.devStore.viewPorts.find(e => e.viewportID === props.viewportID).MessageBox;
}

function containerHidden() {
}
onMounted(()=>{

});

onBeforeMount(()=>{
  //initialFormProperties();
})

function show() {
  container.value.show();
}

function hide() {
  container.value.hide();
}

function showContainerAlignedToElement(...args) {
  container.value.showModalAlignedToElement(...args)
}

function showContainerAlignedToElementInViewport(...args) {
  container.value.showContainerAlignedToElementInViewport(...args)
}

/**
 * Form-related items
 */


defineExpose({
  show,
  hide,
  showContainerAlignedToElement,
  showContainerAlignedToElementInViewport
});
</script>

<style>
/*@import url('/simplia/dist/css/suite.min.css');*/
</style>